import { useState } from 'react';

import { Button } from '@/components/Button';
import { Input } from '@/components/Inputs';
import Modal from '@/components/Modal/Modal';

interface AddRoleModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
}

export function AddRoleModal({ open, onClose, onConfirm }: AddRoleModalProps) {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    setName('');
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Add Role">
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Input
          label="Role Name"
          placeholder="e.g. Engineer"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Button type="submit">Add Role</Button>
      </form>
    </Modal>
  );
}
